import {Component, Input, OnInit, Optional} from '@angular/core';
import {Questionnaire} from '@ngmedax/common-questionnaire-types';
import {Translatable, TranslationService} from '@ngmedax/translation';
import {TRANSLATION_EDITOR_SCOPE} from '../../../../constants';
import {KEYS} from '../../../../translation-keys';


// hack to inject decorator declarations. must occur before class declaration!
export interface QuestionTypeNumericComponent extends Translatable {}

@Component({
  selector: 'app-qa-question-numeric',
  templateUrl: './question-type-numeric.component.html',
  styleUrls: ['./question-type-numeric.component.css']
})
@Translatable({scope: TRANSLATION_EDITOR_SCOPE, keys: KEYS})
export class QuestionTypeNumericComponent implements OnInit {
  @Input() question: Questionnaire.Container;
  // @Input() mapping: Questionnaire.Container.ComponentMapping;

  /**
   * UI display mode for numeric input:
   * - input: plain text input field (sets displayType 'text' and disables wheel picker)
   * - wheel: number wheel picker (sets displayType 'text' and enables wheel picker by not setting disableWheelPicker)
   * - slider: slider (sets displayType 'slider')
   */
  public numericDisplayMode: 'input' | 'wheel' | 'slider' = 'input';

  /**
   * Locale for questionnaire. Hardcoded to "de_DE" for now.
   * We need to change this, when we implement multi language support
   * @type {string}
   */
  public locale = 'de_DE';

  /**
   * Input steps
   * @type {string}
   */
  public steps = '1';

  /**
   * Injects dependencies
   */
  public constructor(
    @Optional() private translationService: TranslationService
  ) {
  }

  public ngOnInit() {
    if (!this.question.options) {
      this.question.options = {};
    }

    if (!this.question.options.unit || typeof this.question.options.unit['de_DE'] === 'undefined') {
      this.question.options.unit = {
        'de_DE': ''
      };
    }

    // initialize UI display mode from question state (early bail-out)
    if (this.question.displayType === 'slider') {
      this.numericDisplayMode = 'slider';
      this.initScaleLabels();
      this.onUpdateSteps();
      return;
    }
    const disableWheel = this.question.options.disableWheelPicker === true;
    this.numericDisplayMode = disableWheel ? 'input' : 'wheel';

    this.onUpdateSteps();
  }

  /**
   * Updates input steps
   */
  public onUpdateSteps() {
    this.steps = (this.question.options.steps + '')
      .replace(/0*\d/g,'0')
      .replace(/[0-9]$/, '1');
  }

  /**
   * Updates question.displayType and options based on UI display mode selection
   */
  public onDisplayModeChange(mode: 'input' | 'wheel' | 'slider') {
    // ensure options object
    if (!this.question.options) {
      this.question.options = {};
    }

    // early bail-out style
    if (mode === 'slider') {
      this.question.displayType = 'slider' as any;
      this.question.options.disableWheelPicker !== undefined && delete this.question.options.disableWheelPicker;
      this.initScaleLabels();
      return;
    }

    if (mode === 'wheel') {
      this.question.displayType = 'text' as any;
      this.question.options.disableWheelPicker !== undefined && delete this.question.options.disableWheelPicker;
      return;
    }

    // input (default)
    this.question.displayType = 'text' as any;
    this.question.options.disableWheelPicker = true;
  }

  /**
   * Initializes scale label fields for slider mode
   */
  private initScaleLabels() {
    if (!this.question.options.scaleStartLabel
      || typeof this.question.options.scaleStartLabel['de_DE'] === 'undefined') {
      this.question.options.scaleStartLabel = {'de_DE': ''};
    }

    if (!this.question.options.scaleEndLabel
      || typeof this.question.options.scaleEndLabel['de_DE'] === 'undefined') {
      this.question.options.scaleEndLabel = {'de_DE': ''};
    }
  }
}
